/**
 * CasualCompetitors 页面筛选器 URL 参数配置
 */
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import { REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';

// 默认筛选器值
export const DEFAULT_FILTER_VALUE = {
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.REGION]: {
    type: 'market',
    regions: [],
    markets: ['global'],
  },
  [filterKeyMap.PLATFORM]: {
    value: ['appstore', 'googleplay'],
  },
  [filterKeyMap.REVENUE_SCOPE]: {
    value: REVENUE_SCOPE_VALUES.EXCLUDING,
  },
};

// URL参数配置
export const CASUAL_COMPETITORS_FILTER_URL_CONFIG = {
  // 主品类Tab
  primary_tab: {
    inputPath: 'primaryTab',
    input: 'string',
    output: 'string',
    outputPath: 'primary_tab',
  },
  // IAA子品类Tab
  secondary_tab: {
    inputPath: 'secondaryTab',
    input: 'string',
    output: 'string',
    outputPath: 'secondary_tab',
  },
  // 时间粒度
  granularity: {
    inputPath: 'rangeTime/type',
    input: 'string',
    output: 'string',
    outputPath: 'granularity',
  },
  // 开始日期
  start_date: {
    inputPath: 'rangeTime/value/0',
    input: 'startDate',
    output: 'string',
    defaultGranularity: 'monthly',
    outputPath: 'start_date',
    outputConditionKey: 'granularity',
  },
  // 结束日期
  end_date: {
    inputPath: 'rangeTime/value/1',
    input: 'endDate',
    output: 'string',
    defaultGranularity: 'monthly',
    outputPath: 'end_date',
    outputConditionKey: 'granularity',
  },
  // 地区
  region: {
    inputPath: 'region/markets',
    input: 'array',
    output: 'array',
    outputPath: 'region',
  },
  // 平台 (注意：filterKeyMap.PLATFORM = 'platForm'，inputPath需要匹配)
  platform: {
    inputPath: 'platForm/value',
    input: 'array',
    output: 'array',
    outputPath: 'platform',
  },
};

export const CASUAL_COMPETITORS_REVENUE_SCOPE_FILTER_URL_CONFIG = {
  revenue_scope: {
    inputPath: `${filterKeyMap.REVENUE_SCOPE}/value`,
    input: 'string',
    output: 'string',
    outputPath: filterKeyMap.REVENUE_SCOPE,
  },
};
